// import { encryptData } from "../Secure_data";


  export const signUp = (gender,token, payment_status) => ({
    type: 'SIGNUP',
    payload: {
      gender: gender, 
      token: token,
      payment_status: payment_status
    }
  });
  export const Gender_Change = (gender) => ({
    type: 'Gender',
    payload: {
      gender: gender, 
    }
  });

  
 
export const login = (gender, user_type,onboarding,payment_status, token,verfied ) => ({
    type: 'LOGIN',
    payload: { 
      gender: gender, 
      user_type: user_type, 
      onboarding: onboarding,
      payment_status: payment_status, 
      token: token,
      verfied: verfied
    }
  });


   
export const verify_email = (verfied) => ({
  type: 'verify_email',
  payload: { 
    verfied: verfied, 
  }
});
export const payment_status = (payment_status) => ({
  type: 'payment_status',
  payload: { 
    payment_status: payment_status, 
  }
});



 
  
  export const onBoarding = (onboarding) => ({
    type: 'ONBOARDING',
    payload: {
      onboarding: onboarding
    }
  });
  
  export const Logout = () => ({
    type: 'Logout',
  });

